import PropTypes from "prop-types";
import InsuranceCustomerModal from "../shared/InsuranceCustomerModal";

const AddInsuranceCustomerModal = (props) => (
    <InsuranceCustomerModal translationNamespace="sellInsurance" {...props} />
);

AddInsuranceCustomerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    mode: PropTypes.oneOf(["create", "edit"]).isRequired,
    provider: PropTypes.string,
    initialUser: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
};

AddInsuranceCustomerModal.defaultProps = {
    provider: undefined,
    initialUser: null,
    onSuccess: null,
};

export default AddInsuranceCustomerModal;
